"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2771,8662],{

/***/ 9367:
/***/ (function(module) {



const denyList = new Set([
	'ENOTFOUND',
	'ENETUNREACH',

	// SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
	'UNABLE_TO_GET_ISSUER_CERT',
	'UNABLE_TO_GET_CRL',
	'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
	'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
	'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
	'CERT_SIGNATURE_FAILURE',
	'CRL_SIGNATURE_FAILURE',
	'CERT_NOT_YET_VALID',
	'CERT_HAS_EXPIRED',
	'CRL_NOT_YET_VALID',
	'CRL_HAS_EXPIRED',
	'ERROR_IN_CERT_NOT_BEFORE_FIELD',
	'ERROR_IN_CERT_NOT_AFTER_FIELD',
	'ERROR_IN_CRL_LAST_UPDATE_FIELD',
	'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
	'OUT_OF_MEM',
	'DEPTH_ZERO_SELF_SIGNED_CERT',
	'SELF_SIGNED_CERT_IN_CHAIN',
	'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
	'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
	'CERT_CHAIN_TOO_LONG',
	'CERT_REVOKED',
	'INVALID_CA',
	'PATH_LENGTH_EXCEEDED',
	'INVALID_PURPOSE',
	'CERT_UNTRUSTED',
	'CERT_REJECTED',
	'HOSTNAME_MISMATCH'
]);

// TODO: Use `error?.code` when targeting Node.js 14
module.exports = error => !denyList.has(error && error.code);


/***/ }),

/***/ 6229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NewsItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Layout/Breadcrumb/index.tsx + 1 modules
var Breadcrumb = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
;// CONCATENATED MODULE: ./src/components/Layout/InternalCredits/index.tsx




function InternalCredits(param) {
    var autoria = param.autoria, urlAutoria = param.urlAutoria, editoria = param.editoria, urlEditoria = param.urlEditoria, datas = param.datas, _type = param.type, type = _type === void 0 ? "" : _type;
    var rel = {};
    if (type === "artigo" || type === "analise") Object.assign(rel, {
        rel: "author"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: "mt-2 text-base font-light text-mglGray700 [&>a]:cursor-pointer [&>a]:text-mglGray700 [&>a]:no-underline",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Por\xa0",
                    urlAutoria ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: "text-mglBlue600 text-opacity-100 shadow-[inset_0_-8px_0_0_rgb(39_169_225_/_10%)] transition-all duration-500 hover:shadow-[inset_0_-1.15em_0_rgb(39_169_225_/_10%)]",
                        style: {
                            color: designSystemColors/* mglBlue.mglBlue600 */.Db.mglBlue600
                        },
                        href: urlAutoria
                    }, rel), {
                        children: autoria
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            " ",
                            autoria,
                            " "
                        ]
                    }),
                    typeof editoria !== "undefined" && editoria !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "\xa0• Editado por\xa0",
                            urlEditoria ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "text-mglBlue600 text-opacity-100 shadow-[inset_0_-8px_0_0_rgb(39_169_225_/_10%)] transition-all duration-500 hover:shadow-[inset_0_-1.15em_0_rgb(39_169_225_/_10%)]",
                                style: {
                                    color: designSystemColors/* mglBlue.mglBlue600 */.Db.mglBlue600
                                },
                                href: urlEditoria,
                                children: editoria
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    " ",
                                    editoria,
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }),
            datas.PublicacaoFormatada && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "\xa0|\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                        dateTime: datas.Publicacao,
                        children: datas.PublicacaoFormatada
                    })
                ]
            }),
            datas.AtualizacaoFormatada && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "\xa0•\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("time", {
                        dateTime: datas.Atualizacao,
                        children: [
                            "Atualizado ",
                            datas.AtualizacaoFormatada
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/InternalTitle/index.tsx
var InternalTitle = __webpack_require__(2434);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
;// CONCATENATED MODULE: ./src/components/Internals/Header/index.tsx





function Header(param) {
    var breadcrumb = param.breadcrumb, titulo = param.titulo, publicacao = param.publicacao, _isAdvertorial = param.isAdvertorial, isAdvertorial = _isAdvertorial === void 0 ? false : _isAdvertorial, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _type = param.type, type = _type === void 0 ? "" : _type;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var headerSpan = currentSpan && currentSpan.startChild({
        op: "header"
    });
    var datas = {
        Publicacao: publicacao.dataPublicacao,
        PublicacaoFormatada: publicacao.dataPublicacaoFormatada,
        Atualizacao: publicacao.dataAtualizacao,
        AtualizacaoFormatada: publicacao.dataAtualizacaoFormatada
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                breadcrumbList: breadcrumb,
                isSubDomain: isSubDomain
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalTitle/* default */.Z, {
                title: titulo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalCredits, {
                autoria: publicacao.autor.nome,
                urlAutoria: publicacao.autor.link,
                editoria: publicacao.editor && !isAdvertorial ? publicacao.editor.nome : null,
                urlEditoria: publicacao.editor && !isAdvertorial ? publicacao.editor.link : null,
                datas: datas,
                type: type
            }),
            headerSpan && headerSpan.finish()
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/WrapperContent/index.tsx
var WrapperContent = __webpack_require__(3078);
// EXTERNAL MODULE: ./src/components/Layout/ItemListLastNews/styles.tsx
var styles = __webpack_require__(2747);
// EXTERNAL MODULE: ./src/components/Ads/Google/AdsTypeGeneratorsMemo/index.tsx
var AdsTypeGeneratorsMemo = __webpack_require__(9831);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./src/components/Internals/NewsItem/styles.tsx
var NewsItem_styles = __webpack_require__(6561);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./src/components/Layout/IFrameYoutube/index.tsx
var IFrameYoutube = __webpack_require__(3251);
// EXTERNAL MODULE: ./src/components/Internals/HeaderImage/index.tsx
var HeaderImage = __webpack_require__(8964);
// EXTERNAL MODULE: ./src/components/Ads/Rearrangers/index.ts
var Rearrangers = __webpack_require__(354);
// EXTERNAL MODULE: ./src/hooks/useScriptFlag.ts
var useScriptFlag = __webpack_require__(1436);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/Ads/AdMembrana/index.tsx



function AdMembrana() {
    var shouldRenderAds = (0,useScriptFlag/* default */.Z)({
        adFlag: "membrana"
    });
    return shouldRenderAds ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "CLT_VIDEO_DIV",
        className: "CLT_VIDEO",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                src: "https://cdn.membrana.media/clt/ym.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                dangerouslySetInnerHTML: {
                    __html: "\n            window.yieldMasterCmd = window.yieldMasterCmd || [];\n            window.yieldMasterCmd.push(function () {\n              window.yieldMaster.init({\n                pageVersionAutodetect: true,\n              });\n            });\n      "
                }
            })
        ]
    }) : null;
}

;// CONCATENATED MODULE: ./src/components/Ads/AdTruvid/index.tsx



function AdTruvid() {
    var hasRendered = (0,react.useRef)(false);
    var shouldRenderAds = (0,useScriptFlag/* default */.Z)({
        adFlag: "truvid"
    });
    var appendScript = function() {
        if (hasRendered.current) return;
        var existingComponent = document.getElementById("truvidPos");
        if (!existingComponent) return;
        var existingScript = document.getElementById("truvid");
        if (existingScript) return;
        var script = document.createElement("script");
        script.id = "truvid";
        script.setAttribute("delayedSrc", "https://cnt.trvdp.com/js/455/9332.js");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        var truvidParent = document.getElementById("truvidPos");
        truvidParent.appendChild(script);
        hasRendered.current = true;
        setTimeout(function() {
            script.setAttribute("src", script.getAttribute("delayedSrc"));
        }, 5000);
    };
    (0,react.useEffect)(function() {
        if (shouldRenderAds) appendScript();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "truvidPos",
        className: "truvidPos"
    });
}

// EXTERNAL MODULE: ./src/components/Internals/NewsContent/styles.tsx
var NewsContent_styles = __webpack_require__(2657);
// EXTERNAL MODULE: ./src/components/Internals/CustomComponentComposer/index.tsx + 5 modules
var CustomComponentComposer = __webpack_require__(5001);
// EXTERNAL MODULE: ./src/components/Internals/ContentComposer/index.tsx + 1 modules
var ContentComposer = __webpack_require__(944);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
// EXTERNAL MODULE: ./src/components/Layout/Icon/index.tsx
var Icon = __webpack_require__(6008);
;// CONCATENATED MODULE: ./src/components/Layout/ChannelsCard/index.tsx


function ChannelsCard() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-[24px] flex flex-col items-center justify-between gap-4 rounded-md bg-white p-4 text-center shadow-mdc-elevation-z9-3 outline outline-2 outline-[#25D366] phone:flex-row phone:text-left",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center gap-x-4 text-ellipsis ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "Canaltech",
                        width: 57,
                        height: 57,
                        src: "https://img.canaltech.com.br/canaltech-icon.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm font-semibold",
                                children: "O Canaltech est\xe1 no WhatsApp!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs font-light",
                                children: "Entre no canal e acompanhe not\xedcias e dicas de tecnologia"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col items-center justify-center tablet:flex-row tablet:justify-between desktop:flex-col largeDesktop:flex-row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "canal-ct-wpp",
                    href: "https://canalte.ch/canaltech-no-whatsapp-site",
                    target: "_blank",
                    title: "WhatsApp Canaltech",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-[136px] items-center justify-center rounded-[80px] bg-[#25D366] p-2 text-center text-xs text-white transition transition-all ease-in hover:bg-black",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                icon: "mdi:whatsapp",
                                fontSize: "0.50rem"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-2",
                                children: "WhatsApp"
                            })
                        ]
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Internals/NewsContent/index.tsx
/* eslint-disable no-shadow */ /* eslint-disable react/no-array-index-key */ 














var MoreAbout = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6790).then(__webpack_require__.bind(__webpack_require__, 6790));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6790)
            ];
        }
    }
});
function NewsContent(param) {
    var dataContent = param.dataContent, _widget = param.widget, widget = _widget === void 0 ? null : _widget, _placeholderAds = param.placeholderAds, placeholderAds = _placeholderAds === void 0 ? false : _placeholderAds, _shouldRenderAdsGoogle = param.shouldRenderAdsGoogle, shouldRenderAdsGoogle = _shouldRenderAdsGoogle === void 0 ? true : _shouldRenderAdsGoogle, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _product = param.product, product = _product === void 0 ? null : _product, _titulo = param.titulo, titulo = _titulo === void 0 ? "" : _titulo, _hasPartnerLinks = param.hasPartnerLinks, hasPartnerLinks = _hasPartnerLinks === void 0 ? false : _hasPartnerLinks, _isNewsOpen = param.isNewsOpen, isNewsOpen = _isNewsOpen === void 0 ? false : _isNewsOpen, _useMembrana = param.useMembrana, useMembrana = _useMembrana === void 0 ? false : _useMembrana, _mainCategory = param.mainCategory, mainCategory = _mainCategory === void 0 ? "" : _mainCategory;
    var ref;
    var transaction = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getTransaction();
    var newsContentSpan = transaction && transaction.startChild({
        op: "newsContent"
    });
    var chunckContent = (0,Rearrangers/* contentRearranger */.eS)({
        content: dataContent.conteudo,
        useTruvid: !useMembrana && !hasPartnerLinks,
        useMembrana: useMembrana && !hasPartnerLinks
    });
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("phone"), 1), isMobile = ref1[0];
    var ref2 = (0,react.useState)(isNewsOpen), isOpen = ref2[0], setOpened = ref2[1];
    var handleClickOpened = function() {
        setOpened(!isOpen);
    };
    var whenMobileAndShortContent = isMobile && dataContent.conteudo.length < 9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!widget && /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreAbout, {
                type: widget.tipo,
                dados: widget.dados,
                isSubDomain: isSubDomain,
                product: product && {
                    preco: product.preco,
                    encurtador: product.encurtador || product.url
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsContent_styles/* DivContentNews */._7, {
                children: chunckContent === null || chunckContent === void 0 ? void 0 : chunckContent.map(function(partHtml, index) {
                    var idCountPosition = partHtml.idCountPosition ? partHtml.idCountPosition : "";
                    var whenMobileAndLongContentAndReadMore = isMobile && dataContent.conteudo.length >= 8 && chunckContent.indexOf(partHtml) <= 14 && !isOpen;
                    var shouldRenderFullWhenMainCategoryIsMatch = [
                        "Ci\xeancia",
                        "Entretenimento"
                    ].includes(mainCategory);
                    var shouldShow = shouldRenderFullWhenMainCategoryIsMatch || isOpen || !isMobile || whenMobileAndShortContent || whenMobileAndLongContentAndReadMore;
                    if (partHtml.tipo === "cardCTA") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelsCard, {})
                        }, index);
                    }
                    if (partHtml.tipo === "adMobile") {
                        var adMobileSpan = newsContentSpan && newsContentSpan.startChild({
                            op: "adRectangleMainInternalM"
                        });
                        return isMobile && shouldRenderAdsGoogle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(shouldShow ? "flex" : "hidden", " min-h-[340px] flex-col"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mb-1 h-3 text-center text-[10px] uppercase tracking-[0.05em] text-mglGray500",
                                    children: "Continua ap\xf3s a publicidade"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                                    isPlaceholder: placeholderAds,
                                    type: "rectangle/main/internal",
                                    marginBottomP: "24px",
                                    idCountPosition: idCountPosition
                                }, index),
                                adMobileSpan && adMobileSpan.finish()
                            ]
                        }, "".concat(index));
                    }
                    if (partHtml.tipo === "adDesktop") {
                        var adDesktopSpan = newsContentSpan && newsContentSpan.startChild({
                            op: "adRectangleMainInternalD"
                        });
                        return !isMobile && shouldRenderAdsGoogle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(shouldShow ? "flex" : "hidden", " min-h-[340px] flex-col"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mb-1 h-3 text-center text-[10px] uppercase tracking-[0.05rem] text-mglGray500",
                                    children: "Continua ap\xf3s a publicidade"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                                    isPlaceholder: placeholderAds,
                                    type: "rectangle/main/internal",
                                    marginBottomP: "24px",
                                    idCountPosition: idCountPosition
                                }, index),
                                adDesktopSpan && adDesktopSpan.finish()
                            ]
                        }, "".concat(index));
                    }
                    if (partHtml.tipo === "adMembranaDesktop" && !isMobile) {
                        var adMembranaSpan = newsContentSpan && newsContentSpan.startChild({
                            op: "adMembrana"
                        });
                        return !isMobile && !hasPartnerLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(shouldShow ? "block" : "hidden", "z-[2] mx-auto mb-4 aspect-video h-full w-full items-center justify-center bg-black/5", placeholderAds && "bg-mglGray200 text-mglGray300 before:flex before:h-full before:items-center before:justify-center before:content-['PUBLICIDADE']"),
                            children: [
                                !placeholderAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdMembrana, {}),
                                adMembranaSpan && adMembranaSpan.finish()
                            ]
                        }, "".concat(index));
                    }
                    if (partHtml.tipo === "adTruvidDesktop" && !isMobile) {
                        var adTruvidSpan = newsContentSpan && newsContentSpan.startChild({
                            op: "adTruvid"
                        });
                        return !isMobile && !hasPartnerLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(shouldShow ? "block" : "hidden", "z-[2] mx-auto mb-4 aspect-video h-full w-full items-center justify-center bg-black/5 [&>.truvidPos]:grid [&>.truvidPos]:aspect-video [&>.truvidPos]:items-center", placeholderAds && "bg-mglGray200 text-mglGray300 before:flex before:h-full before:items-center before:justify-center before:content-['PUBLICIDADE']"),
                            children: [
                                !placeholderAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdTruvid, {}),
                                adTruvidSpan && adTruvidSpan.finish()
                            ]
                        }, "".concat(index));
                    }
                    if (partHtml.tipo === "adMembranaMobile" && isMobile) {
                        var adMembranaSpan1 = newsContentSpan && newsContentSpan.startChild({
                            op: "adMembrana"
                        });
                        return isMobile && !hasPartnerLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(shouldShow ? "block" : "hidden", "z-[2] mx-auto mb-4 aspect-video h-full w-full items-center justify-center self-start", placeholderAds && "bg-mglGray200 text-mglGray300 before:flex before:h-full before:items-center before:justify-center before:content-['PUBLICIDADE']"),
                            children: [
                                !placeholderAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdMembrana, {}),
                                adMembranaSpan1 && adMembranaSpan1.finish()
                            ]
                        }, "".concat(index));
                    }
                    if (partHtml.tipo === "adTruvidMobile" && isMobile) {
                        var adTruvidSpan1 = newsContentSpan && newsContentSpan.startChild({
                            op: "adTruvid"
                        });
                        return isMobile && !hasPartnerLinks && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(shouldShow ? "block" : "hidden", "z-[2] mx-auto mb-4 aspect-video h-full w-full items-center justify-center self-start [&>.truvidPos]:grid [&>.truvidPos]:aspect-video [&>.truvidPos]:items-center [&>.truvidPos]:bg-black/5", placeholderAds && "bg-mglGray200 text-mglGray300 before:flex before:h-full before:items-center before:justify-center before:content-['PUBLICIDADE']"),
                            children: [
                                !placeholderAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdTruvid, {}),
                                adTruvidSpan1 && adTruvidSpan1.finish()
                            ]
                        }, "".concat(index));
                    }
                    if ((0,CustomComponentComposer/* isCustomComponent */.m)(partHtml)) {
                        var customComposerSpan = newsContentSpan && newsContentSpan.startChild({
                            op: "customComposer",
                            description: JSON.stringify(partHtml)
                        });
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,className/* default */.Z)(shouldShow ? "block" : "hidden"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomComponentComposer/* default */.Z, {
                                    partHtml: partHtml,
                                    index: index,
                                    titulo: titulo
                                }, index),
                                customComposerSpan && customComposerSpan.finish()
                            ]
                        }, "".concat(index));
                    }
                    if (partHtml.tipo === "readMore" && !shouldRenderFullWhenMainCategoryIsMatch) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: !isOpen && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative z-[2] -ml-4 -mt-36 flex h-[200px] w-[calc(100%_+_2rem)] flex-col justify-end bg-gradient-to-t from-mglBlue400 via-mglBlue300 to-75% px-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "mb-12 flex w-full items-center justify-center rounded-[2rem] border-0 bg-mglGray900 p-2 text-base font-medium text-mglGray50 outline-none transition-all ease-in-out [&_svg]:ml-2 [&_svg]:fill-mglGray50",
                                    id: "read-more",
                                    onClick: handleClickOpened,
                                    children: "continuar lendo"
                                })
                            })
                        }, index);
                    }
                    var contentComposerSpan = newsContentSpan && newsContentSpan.startChild({
                        op: "contentComposer",
                        description: JSON.stringify(partHtml)
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentComposer/* default */.Z, {
                                tipo: partHtml.tipo,
                                as: partHtml.tag,
                                url: partHtml.url,
                                target: partHtml.target,
                                valor: partHtml === null || partHtml === void 0 ? void 0 : partHtml.valor,
                                atributos: partHtml === null || partHtml === void 0 ? void 0 : partHtml.atributos,
                                className: (0,className/* default */.Z)(shouldShow ? "" : "hidden")
                            }, "".concat(partHtml.tipo, "-").concat(index)),
                            contentComposerSpan && contentComposerSpan.finish()
                        ]
                    }, "".concat(index));
                })
            }),
            newsContentSpan && newsContentSpan.finish()
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Internals/Header/AdvertorialTag/index.tsx

function AdvertorialTag() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "inline-block h-8 w-[144px] rounded-[30px] border border-solid border-mglGray500 text-center text-xs font-medium uppercase leading-8 text-mglGray500",
        children: "PUBLIEDITORIAL"
    });
}

// EXTERNAL MODULE: ./src/components/Layout/Modal/index.tsx
var Modal = __webpack_require__(4775);
// EXTERNAL MODULE: ./src/components/Internals/Widgets/NewsLetter/NewsLetter.tsx
var NewsLetter = __webpack_require__(7601);
;// CONCATENATED MODULE: ./src/components/Layout/InternalShareButton/index.tsx














function InternalShareButton(param) {
    var title = param.title, description = param.description, url = param.url, _isAdvertorial = param.isAdvertorial, isAdvertorial = _isAdvertorial === void 0 ? false : _isAdvertorial;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var internalShareButtonSpan = currentSpan && currentSpan.startChild({
        op: "internalShareButton"
    });
    var ref1 = (0,react.useState)(false), isMenuOpen = ref1[0], setIsMenuOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isNewsletterModalOpen = ref2[0], setIsNewsletterModalOpen = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("phone"), 1), isMobile = ref3[0];
    var InternalBtnList = [
        {
            name: "Whatsapp",
            link: "https://web.whatsapp.com/send?text=".concat(encodeURIComponent(title), " ").concat(url),
            icon: "whatsapp",
            bgColor: "#25d366",
            linkApp: "whatsapp://send?text=".concat(encodeURIComponent(title), " ").concat(url),
            show: isMenuOpen
        },
        {
            name: "Facebook",
            link: "https://www.facebook.com/sharer/sharer.php?u=".concat(url),
            icon: "facebook",
            bgColor: "#3b5998",
            show: isMenuOpen
        },
        {
            name: "E-mail",
            link: "mailto:?subject=".concat(encodeURIComponent(title), "&body=").concat(encodeURIComponent(description), "%0D%0A%0D%0A Veja o conte\xfado completo em ").concat(url),
            icon: "email",
            bgColor: designSystemColors/* mglGray.mglGray900 */.Ce.mglGray900,
            show: isMenuOpen
        },
        {
            name: "Link",
            link: url,
            icon: "link-variant",
            bgColor: "#999",
            message: "Link copiado!",
            copyClipboard: true,
            show: isMenuOpen
        }, 
    ];
    var MobileBtnList = [
        {
            name: "Whatsapp",
            link: "https://web.whatsapp.com/send?text=".concat(encodeURIComponent(title), " ").concat(url),
            icon: "whatsapp",
            bgColor: "#25d366",
            linkApp: "whatsapp://send?text=".concat(encodeURIComponent(title), " ").concat(url),
            show: isMenuOpen
        },
        {
            name: "Facebook",
            link: "https://www.facebook.com/sharer/sharer.php?u=".concat(url),
            icon: "facebook",
            bgColor: "#3b5998",
            show: isMenuOpen
        },
        {
            name: "Link",
            link: url,
            icon: "link-variant",
            bgColor: "#999",
            message: "Link copiado!",
            copyClipboard: true,
            show: isMenuOpen
        },
        {
            name: "Newsletter",
            link: "#",
            icon: "email-outline",
            bgColor: "#007bff",
            show: isMenuOpen
        }, 
    ];
    var getCorrectLink = function(btnProps) {
        var link;
        if (isMobile && (btnProps.name === "Whatsapp" || btnProps.name === "Telegram")) {
            link = btnProps.linkApp;
        } else if (btnProps.copyClipboard) {
            link = "";
        } else {
            link = btnProps.link;
        }
        return link;
    };
    // Mobile Layout Component
    var MobileLayout = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-8 flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex flex-col items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex w-full flex-row items-center justify-center gap-3 rounded-lg bg-mglGray50",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full flex-row items-center justify-between gap-3",
                                children: MobileBtnList.map(function(internalBtnProps) {
                                    var Tag = internalBtnProps.name === "Link" || internalBtnProps.name === "Newsletter" ? "button" : "a";
                                    var linkProps = {};
                                    if (getCorrectLink(internalBtnProps)) {
                                        linkProps = {
                                            href: getCorrectLink(internalBtnProps),
                                            target: "_blank",
                                            rel: "noreferrer"
                                        };
                                    }
                                    if (internalBtnProps.name === "Newsletter") {
                                        return /*#__PURE__*/ (0,react.createElement)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            id: internalBtnProps.name,
                                            className: "gap-1 px-2 share-button-click flex h-8 items-center justify-center rounded-full shadow-sm transition-all duration-200 hover:scale-105",
                                            style: {
                                                backgroundColor: internalBtnProps.bgColor,
                                                border: 0
                                            }
                                        }, linkProps), {
                                            onClick: function(e) {
                                                e.preventDefault();
                                                setIsNewsletterModalOpen(true);
                                                setIsMenuOpen(false);
                                            },
                                            key: "btn-share-" + internalBtnProps.name,
                                            title: "Compartilhar com ".concat(internalBtnProps.name),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    icon: "mail-send",
                                                    width: 22,
                                                    height: 12,
                                                    color: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
                                                    viewBox: "0 0 24 24"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-sm font-medium text-white whitespace-nowrap leading-tight",
                                                    children: "Assine nossa Newsletter"
                                                })
                                            ]
                                        }));
                                    }
                                    return /*#__PURE__*/ (0,react.createElement)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        id: internalBtnProps.name,
                                        className: "share-button-click flex h-8 w-8 items-center justify-center rounded-full shadow-sm transition-all duration-200 hover:scale-105",
                                        style: {
                                            backgroundColor: internalBtnProps.bgColor,
                                            border: 0
                                        }
                                    }, linkProps), {
                                        onClick: function(e) {
                                            if (internalBtnProps.copyClipboard) {
                                                e.preventDefault();
                                                navigator.clipboard.writeText(internalBtnProps.link);
                                                window.alert(internalBtnProps.message);
                                            }
                                            setIsMenuOpen(false);
                                        },
                                        key: "btn-share-" + internalBtnProps.name,
                                        title: "Compartilhar com ".concat(internalBtnProps.name)
                                    }), /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,className/* default */.Z)("flex items-center justify-center text-xl", internalBtnProps.name === "Link" && "share-button-click"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, internalBtnProps.name === "Link" && {
                                            id: "LinkSVG"
                                        }), {
                                            icon: "mdi:".concat(internalBtnProps.icon),
                                            width: 20,
                                            height: 20,
                                            color: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
                                            viewBox: "0 0 24 24"
                                        }), internalBtnProps.name === "Link" && {
                                            className: "share-button-click"
                                        }))
                                    }));
                                })
                            })
                        })
                    })
                }),
                isAdvertorial && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertorialTag, {})
            ]
        });
    };
    // Desktop Layout Component
    var DesktopLayout = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mb-8 flex flex-col flex-wrap justify-between gap-3 tablet:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mr-2 text-base font-light text-mglGray700",
                            children: "Compartilhe: "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex flex-row items-center justify-center gap-2 rounded bg-mglGray50 transition-all duration-300 ease-ease",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-wrap justify-center gap-2 tablet:flex-nowrap tablet:justify-normal",
                                children: InternalBtnList.map(function(internalBtnProps) {
                                    var Tag = internalBtnProps.name === "Link" ? "button" : "a";
                                    var linkProps = {};
                                    if (getCorrectLink(internalBtnProps)) {
                                        linkProps = {
                                            href: getCorrectLink(internalBtnProps),
                                            target: "_blank",
                                            rel: "noreferrer"
                                        };
                                    }
                                    return /*#__PURE__*/ (0,react.createElement)(Tag, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        id: internalBtnProps.name,
                                        className: "share-button-click flex h-8 w-8 items-center justify-center rounded-half",
                                        style: {
                                            backgroundColor: internalBtnProps.bgColor,
                                            border: 0
                                        }
                                    }, linkProps), {
                                        onClick: function(e) {
                                            if (internalBtnProps.copyClipboard) {
                                                e.preventDefault();
                                                navigator.clipboard.writeText(internalBtnProps.link);
                                                window.alert(internalBtnProps.message);
                                            }
                                            setIsMenuOpen(false);
                                        },
                                        key: "btn-share-" + internalBtnProps.name,
                                        title: "Compartilhar com ".concat(internalBtnProps.name)
                                    }), /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,className/* default */.Z)("flex items-center justify-center text-2xl", internalBtnProps.name === "Link" && "share-button-click"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, internalBtnProps.name === "Link" && {
                                            id: "LinkSVG"
                                        }), {
                                            icon: "mdi:".concat(internalBtnProps.icon),
                                            width: 18,
                                            height: 18,
                                            color: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
                                            viewBox: "0 0 24 24"
                                        }), internalBtnProps.name === "Link" && {
                                            className: "share-button-click"
                                        }))
                                    }));
                                })
                            })
                        })
                    ]
                }),
                isAdvertorial && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvertorialTag, {})
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLayout, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopLayout, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                isOpen: isNewsletterModalOpen,
                setIsOpen: setIsNewsletterModalOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "p-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsLetter/* default */.Z, {})
                })
            }),
            internalShareButtonSpan && internalShareButtonSpan.finish()
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Internals/MainContent/index.tsx










var BlackFridayCall = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 81).then(__webpack_require__.bind(__webpack_require__, 81));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81)
            ];
        }
    },
    ssr: false
});
var EmbedOmny = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7788).then(__webpack_require__.bind(__webpack_require__, 5809));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5809)
            ];
        }
    }
});
var PodcastAggregators = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7343).then(__webpack_require__.bind(__webpack_require__, 7343));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7343)
            ];
        }
    }
});
var QuotedNewsBox = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 62).then(__webpack_require__.bind(__webpack_require__, 62)).then(function(mod) {
        return mod.QuotedNewsBox;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62)
            ];
        }
    },
    ssr: false
});
var SponsorBanner = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8814), __webpack_require__.e(3888)]).then(__webpack_require__.bind(__webpack_require__, 4554));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4554)
            ];
        }
    }
});
function MainContainer(param) {
    var headerImgData = param.headerImgData, article = param.article, _mainCategory = param.mainCategory, mainCategory = _mainCategory === void 0 ? "" : _mainCategory, _video = param.video, video = _video === void 0 ? null : _video, _podcast = param.podcast, podcast = _podcast === void 0 ? null : _podcast, _citados = param.citados, citados = _citados === void 0 ? null : _citados, _titulo = param.titulo, titulo = _titulo === void 0 ? "" : _titulo, _type = param.type, type = _type === void 0 ? "" : _type, _capa = param.capa, capa = _capa === void 0 ? null : _capa, _widget = param.widget, widget = _widget === void 0 ? null : _widget, _widgetBf = param.widgetBf, widgetBf = _widgetBf === void 0 ? false : _widgetBf, _placeholderAds = param.placeholderAds, placeholderAds = _placeholderAds === void 0 ? false : _placeholderAds, _shouldRenderAdsGoogle = param.shouldRenderAdsGoogle, shouldRenderAdsGoogle = _shouldRenderAdsGoogle === void 0 ? true : _shouldRenderAdsGoogle, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain, _precos = param.precos, precos = _precos === void 0 ? null : _precos, _flags = param.flags, flags = _flags === void 0 ? 0 : _flags, _editorialCategory = param.editorialCategory, editorialCategory = _editorialCategory === void 0 ? undefined : _editorialCategory, _isHeader = param.isHeader, isHeader = _isHeader === void 0 ? undefined : _isHeader, _description = param.description, description = _description === void 0 ? "" : _description, _url = param.url, url = _url === void 0 ? "" : _url, _isNewsOpen = param.isNewsOpen, isNewsOpen = _isNewsOpen === void 0 ? false : _isNewsOpen, _useMembrana = param.useMembrana, useMembrana = _useMembrana === void 0 ? false : _useMembrana, _enableNewsLetter = param.enableNewsLetter, enableNewsLetter = _enableNewsLetter === void 0 ? false : _enableNewsLetter;
    var ref, ref1;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var mainContentSpan = currentSpan && currentSpan.startChild({
        op: "mainContent"
    });
    var hasPartnerLinks = (flags & 512) !== 0;
    // eslint-disable-next-line no-bitwise
    var isAdvertorial = type === "artigo" && (flags & 2) !== 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,className/* default */.Z)("[grid-column:1] desktop:[grid-column-end:2] desktop:[grid-column-start:1]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalShareButton, {
                        title: titulo,
                        description: description,
                        url: url,
                        isAdvertorial: isAdvertorial
                    }),
                    editorialCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorBanner, {
                        isInternal: true,
                        variant: editorialCategory,
                        isAdvertorial: isAdvertorial
                    }),
                    !!((ref1 = Object.keys(headerImgData)) === null || ref1 === void 0 ? void 0 : ref1.length) && !video && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderImage/* default */.Z, {
                        url: headerImgData.url,
                        srcset: headerImgData.srcset,
                        caption: headerImgData.caption || titulo,
                        editorialCategory: editorialCategory,
                        isHeader: isHeader
                    }),
                    (video === null || video === void 0 ? void 0 : video.idYoutube) && /*#__PURE__*/ (0,jsx_runtime.jsx)(IFrameYoutube/* default */.Z, {
                        videoTitle: video.titulo,
                        videoId: video.idYoutube,
                        capa: capa,
                        lazy: true
                    }),
                    podcast && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedOmny, {
                        titulo: titulo,
                        dataPodcast: podcast
                    }),
                    podcast && /*#__PURE__*/ (0,jsx_runtime.jsx)(PodcastAggregators, {
                        aggregatorsData: article.botoes,
                        dataPodcast: podcast
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsContent, {
                        dataContent: article,
                        widget: widget,
                        placeholderAds: placeholderAds,
                        shouldRenderAdsGoogle: shouldRenderAdsGoogle,
                        isSubDomain: isSubDomain,
                        product: precos && precos.length > 0 && precos[0],
                        titulo: titulo,
                        hasPartnerLinks: hasPartnerLinks,
                        isNewsOpen: isNewsOpen,
                        useMembrana: useMembrana,
                        mainCategory: mainCategory
                    }),
                    enableNewsLetter && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsLetter/* default */.Z, {}),
                    (hasPartnerLinks || editorialCategory === "ctup" || !!(citados === null || citados === void 0 ? void 0 : citados.length) || widgetBf) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.ZP, {
                        height: 1,
                        children: [
                            hasPartnerLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6 rounded bg-mglGray200 p-4 text-xs font-light text-mglGray500",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Este artigo possui links de lojas parceiras do Canaltech. Se voc\xea comprar o produto sugerido, podemos receber uma pequena comiss\xe3o. O programa de afiliados n\xe3o influencia nosso conte\xfado editorial, que tem as liberdades de imprensa e de opini\xe3o garantidas."
                                    })
                                })
                            }),
                            !!(citados === null || citados === void 0 ? void 0 : citados.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotedNewsBox, {
                                citados: citados,
                                type: video ? "video" : "podcast"
                            }),
                            widgetBf && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackFridayCall, {})
                        ]
                    })
                ]
            }),
            mainContentSpan && mainContentSpan.finish()
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Layout/SponsoredCategoryHeader/index.tsx
var SponsoredCategoryHeader = __webpack_require__(2155);
// EXTERNAL MODULE: ./src/lib/sponsors.ts
var sponsors = __webpack_require__(6874);
;// CONCATENATED MODULE: ./src/components/Internals/NewsItem/index.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 














function NewsItem(param) {
    var newsData = param.newsData, _newsPreview = param.newsPreview, newsPreview = _newsPreview === void 0 ? false : _newsPreview, _isCurrentPage = param.isCurrentPage, isCurrentPage = _isCurrentPage === void 0 ? false : _isCurrentPage, _type = param.type, type = _type === void 0 ? "" : _type;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("tablet"), 1), isTabletOrMobile = ref5[0];
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var newsItemSpan = currentSpan && currentSpan.startChild({
        op: "newsItem"
    });
    var SideContent = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 4942).then(__webpack_require__.bind(__webpack_require__, 4942));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(4942)
                ];
            }
        }
    });
    var router = (0,next_router.useRouter)();
    var capa = newsData.capa, conteudo = newsData.conteudo, podcast = newsData.podcast, url = newsData.url;
    var pageUri = url;
    var IdsPg = newsData.widget && ((ref1 = newsData.widget) === null || ref1 === void 0 ? void 0 : ref1.tipo) === "produto" && type === "analise" ? [
        newsData.cu,
        (ref2 = newsData.widget) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.dados) === null || ref3 === void 0 ? void 0 : ref3.cu
    ] : newsData.cu;
    var categories = undefined;
    if (newsData === null || newsData === void 0 ? void 0 : newsData.categorias) categories = newsData === null || newsData === void 0 ? void 0 : newsData.categorias;
    var mainCategory = (newsData === null || newsData === void 0 ? void 0 : newsData.categoriaPrincipal) || undefined;
    var mainCategoryId = (newsData === null || newsData === void 0 ? void 0 : newsData.idCategoriaPrincipal) || undefined;
    var publicationType = newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao;
    // eslint-disable-next-line no-bitwise
    var isAdvertorial = type === "artigo" && (newsData.flags & 2) !== 0;
    var isOffer = type === "artigo" && (newsData.flags & 32) !== 0;
    var socialMediaCategoryId = 36;
    var membranaCategory = mainCategoryId === socialMediaCategoryId;
    var isSponsoredOrEditorialCategory = undefined;
    var editorialCategory = undefined;
    var sponsoredCategory = undefined;
    if (categories && mainCategory) {
        isSponsoredOrEditorialCategory = (0,sponsors/* isSponsoredOrEditorialToInternal */.xu)(mainCategory, categories, publicationType);
        if (categories && isSponsoredOrEditorialCategory === "editorial") {
            editorialCategory = (0,sponsors/* getEditorialCategoryWithStringToInternal */.b3)(categories, mainCategory);
        }
        if ((categories || publicationType) && isSponsoredOrEditorialCategory === "sponsored") {
            sponsoredCategory = (0,sponsors/* getSponsoredCategoryOrTypeWithStringToInternal */.SU)(categories, mainCategory, publicationType);
        }
    }
    var shouldRenderAdsGoogle = !isAdvertorial;
    var shouldRenderAdsByType = type !== "video" && type !== "podcast" && type !== "analise" && type !== "artigo";
    var enableNewsLetter = (newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao) !== "8" && // TIPO_ARTIGOS
    (newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao) !== "11" && // TIPO_LISTAS
    (newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao) !== "2" && // TIPO_ANALISES
    (newsData === null || newsData === void 0 ? void 0 : newsData.tipoPublicacao) !== "4" && // TIPO_TUTORIAIS
    !isAdvertorial && // Publieditorial é uma flag na matéria.
    !isOffer; // Oferta é uma flag na matéria.
    (0,react.useEffect)(function() {
        var navigate = function() {
            router.push(window.location.href);
        };
        window.onpopstate = navigate;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "route-uri",
        "data-uri-page": pageUri,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperContent/* default */.Z, {
                isOnHeader: true,
                hasBreadcrumb: true,
                children: [
                    isSponsoredOrEditorialCategory === "sponsored" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsoredCategoryHeader/* SponseredCategoryHeader */.i, {
                        sponsoredCategory: sponsoredCategory
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        breadcrumb: newsData.breadcrumb,
                        titulo: newsData.titulo,
                        publicacao: newsData.publicacao,
                        isAdvertorial: isAdvertorial,
                        isSubDomain: Boolean(newsData.dominio),
                        type: type
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsItem_styles/* GridInternal */.J, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContainer, {
                                headerImgData: {
                                    url: capa.url,
                                    caption: capa.creditos,
                                    blurhash: capa.blurhash,
                                    srcset: capa.srcset
                                },
                                article: conteudo,
                                mainCategory: mainCategory,
                                widget: (newsData === null || newsData === void 0 ? void 0 : newsData.widget) || conteudo.widget,
                                video: newsData === null || newsData === void 0 ? void 0 : newsData.video,
                                citados: newsData === null || newsData === void 0 ? void 0 : newsData.citados,
                                capa: newsData.capa,
                                podcast: podcast,
                                titulo: newsData.titulo,
                                description: newsData.tituloAlt,
                                url: newsData.encurtador,
                                type: type,
                                placeholderAds: newsPreview,
                                shouldRenderAdsGoogle: shouldRenderAdsGoogle,
                                widgetBf: newsData === null || newsData === void 0 ? void 0 : (ref4 = newsData.conteudo) === null || ref4 === void 0 ? void 0 : ref4.blocoBlackFriday,
                                isSubDomain: Boolean(newsData.dominio),
                                flags: newsData.flags,
                                precos: newsData === null || newsData === void 0 ? void 0 : newsData.precos,
                                editorialCategory: editorialCategory,
                                isHeader: "internal",
                                isNewsOpen: isAdvertorial,
                                useMembrana: membranaCategory
                            }),
                            !isTabletOrMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideContent, {
                                placeholderAds: newsPreview,
                                shouldRenderAds: shouldRenderAdsGoogle,
                                enableNewsLetter: enableNewsLetter
                            })
                        ]
                    })
                ]
            }),
            !newsPreview && shouldRenderAdsByType && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AdContainer */.g1, {
                children: shouldRenderAdsByType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                            type: "billboard/footer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGeneratorsMemo["default"], {
                            type: "rectangle/footer"
                        })
                    ]
                })
            }),
            newsItemSpan && newsItemSpan.finish()
        ]
    });
}


/***/ }),

/***/ 6561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ GridInternal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    GridInternal: {
        singleColumn: {
            true: "singleColumn [&.singleColumn]:desktop:grid-cols-1",
            false: ""
        }
    }
};
var GridInternal = function(_param) {
    var children = _param.children, singleColumn = _param.singleColumn, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleColumn"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("mt-4 grid grid-cols-1 grid-rows-1 gap-0 desktop:grid-cols-[minmax(0,1fr)_336px] desktop:gap-8", singleColumn != undefined && variants.GridInternal.singleColumn[singleColumn.toString()])
    }, rest), {
        children: children
    }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    GridInternal: GridInternal
});


/***/ }),

/***/ 7601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsLetter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8469);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9659);
/* harmony import */ var _components_Layout_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9642);






function NewsLetter(param) {
    var _title = param.title, title = _title === void 0 ? "Seu resumo inteligente do mundo tech!" : _title, _description = param.description, description = _description === void 0 ? "Assine a newsletter do Canaltech e receba not\xedcias e reviews sobre tecnologia em primeira m\xe3o." : _description, _inputPlaceHolder = param.inputPlaceHolder, inputPlaceHolder = _inputPlaceHolder === void 0 ? "Preencha seu e-mail" : _inputPlaceHolder, _buttonContent = param.buttonContent, buttonContent = _buttonContent === void 0 ? "inscreva-se" : _buttonContent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), termChecked = ref1[0], setTermChecked = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasSubmitted = ref2[0], setHasSubmitted = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), responseText = ref3[0], setResponseText = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), responseTitle = ref4[0], setResponseTitle = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), error = ref5[0], setError = ref5[1];
    var handleSubmit = function(event) {
        event.preventDefault();
        if (termChecked) if (email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g)) {
            _services_api__WEBPACK_IMPORTED_MODULE_2__/* .api.post */ .hi.post("/artigo/newsletter/", {
                email: email
            }).then(function(response) {
                if (response.status === 200) {
                    setResponseTitle("Obrigado por se inscrever!");
                    setHasSubmitted(true);
                    setTermChecked(false);
                    setResponseText("Estamos muito felizes em ter voc\xea com a gente!\n" + "Agora voc\xea faz parte da nossa comunidade e receber\xe1, em primeira m\xe3o, as principais not\xedcias e an\xe1lises sobre o mundo da tecnologia.\n\n" + "Fique de olho no seu e-mail — tem muita novidade boa chegando por a\xed!");
                    setError("");
                }
            }).catch(function(err) {
                setError("ResponseError");
                setResponseTitle("Ocorreu um erro!");
            });
        } else {
            setError("ValidationError");
        }
        else {
            setError("ValidationTerm");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (error) {
            var timeout = setTimeout(function() {
                return setError("");
            }, 3000);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        error
    ]);
    var getErrorText = function() {
        if (error === "ValidationError") return "Por favor, verifique se o e-mail foi digitado corretamente.";
        if (error === "ResponseError") return "N\xe3o foi poss\xedvel cadastrar o seu e-mail. Tente novamente.";
        if (error === "ValidationTerm") return "Por favor, aceite os termos de uso e pol\xedtica de privacidade.";
        return "";
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col rounded bg-mglBlue300 p-6 text-mglGray50 mt-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-row",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            width: 34,
                            height: 18.42,
                            icon: "mail-send",
                            color: _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglGray.mglGray50 */ .Ce.mglGray50,
                            className: "mr-2 mt-1"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("font-lexend font-semibold text-base leading-[130%] align-middle", responseTitle === "Obrigado por se inscrever!" ? "mb-0" : "mb-2 "),
                        children: hasSubmitted ? responseTitle : title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mb-6 font-lexend font-normal text-[14px] leading-[150%] tracking-[0px] align-middle",
                children: hasSubmitted ? responseText : description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mb-4 flex w-full flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("mb-2 text-xs font-semibold ", error === "ValidationError" ? "text-[rgb(255,85,85)]" : "text-mglGray50"),
                        children: "E-mail"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                        className: "flex w-full flex-col",
                        onSubmit: function(e) {
                            return handleSubmit(e);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr-4 flex w-full flex-row items-center rounded bg-mglGray50 p-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    className: "h-6 w-full rounded border-none bg-mglGray50 p-2 outline-none font-open-sans font-normal text-xs leading-none tracking-[0%]",
                                    type: "email",
                                    value: email,
                                    autoFocus: error === "ValidationError",
                                    onChange: function(e) {
                                        return setEmail(e.target.value);
                                    },
                                    placeholder: inputPlaceHolder
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "border-1 mt-2 w-full rounded border border-solid border-mglBlue300 bg-mglGray50 p-3 text-mglBlue300 outline-none transition-all duration-300 ease-in-out hover:border-mglGray50 hover:bg-mglBlue300 hover:text-mglGray50",
                                type: "submit",
                                children: buttonContent
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("mt-4 flex flex-row", error === "ValidationTerm" ? "text-[rgb(255,85,85)]" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        checked: termChecked,
                        onClick: function() {
                            return setTermChecked(!termChecked);
                        },
                        className: "text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600 ml-1 mr-1 h-4 w-4 rounded-sm focus:ring-2",
                        id: "newsletter-checkbox"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        htmlFor: "newsletter-checkbox",
                        className: "cursor-pointer font-open-sans font-normal text-[12px] leading-[16px] tracking-[0%] align-middle text-mglGray50",
                        children: [
                            "Confirmo que li, aceito e concordo com os",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://canaltech.com.br/privacidade/",
                                className: "text-mglGray50 font-open-sans font-normal text-[12px] leading-[16px] tracking-[0%] align-middle",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "Termos de Uso e Pol\xedtica de Privacidade do Canaltech."
                                })
                            }),
                            " "
                        ]
                    })
                ]
            }),
            !!error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-2 text-sm text-[rgb(255,85,85)]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                    children: [
                        "*** ",
                        getErrorText()
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 7517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/styles.tsx




var BreadcrumbItemContainer = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex flex-row items-center font-light text-mglGray500 before:mr-2 before:flex before:h-[13px] before:w-2 before:items-center before:justify-center before:pb-[3px] before:text-center before:text-base before:leading-none before:content-['›'] first-of-type:before:content-none"
    }, props), {
        children: props.children
    }));
};
var BreadcrumbItem = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex h-4 flex-row items-center text-xs leading-4 text-mglGray500 no-underline"
    }, props), {
        ref: ref,
        children: props.children
    }));
});


// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/index.tsx
/* eslint-disable react/no-array-index-key */ 





var publicRuntimeConfig = config_default()().publicRuntimeConfig;
function Breadcrumb(param) {
    var breadcrumbList = param.breadcrumbList, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var breadcrumbSpan = currentSpan && currentSpan.startChild({
        op: "breadcrumb"
    });
    var workingList = (0,_to_consumable_array/* default */.Z)(breadcrumbList).filter(function(item) {
        return item.url !== "/";
    });
    workingList.unshift({
        titulo: "Home",
        url: "/"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "place-content-[center_start] mb-2 flex flex-wrap items-center gap-2",
        children: [
            workingList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItemContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: isSubDomain ? "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(item.url) : item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItem, {
                            title: "Ir para ".concat(item.titulo),
                            children: item.titulo
                        })
                    })
                }, item.url);
            }),
            breadcrumbSpan && breadcrumbSpan.finish()
        ]
    });
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 2434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InternalTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function InternalTitle(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
        className: "text-2xl font-medium text-mglGray900 tablet:text-4xl",
        children: title
    });
}


/***/ }),

/***/ 2747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bL": function() { return /* binding */ BillboardContainer; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "hn": function() { return /* binding */ ContentListNews; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





var variants = {
    AdContainer: {
        noPadding: {
            true: "noPadding [&.noPadding]:p-0"
        },
        billboard: {
            true: "h-[250px] hidden tablet:flex"
        }
    },
    ContentListNews: {
        singleRow: {
            true: "grid-rows-[auto]"
        }
    }
};
var AdContainer = function(_param) {
    var children = _param.children, noPadding = _param.noPadding, billboard = _param.billboard, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "noPadding",
        "billboard"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex min-h-0 items-center justify-center bg-mglGray50 px-0 py-5", noPadding != undefined && variants.AdContainer.noPadding[noPadding.toString()], billboard != undefined && variants.AdContainer.billboard[billboard.toString()])
    }, rest), {
        children: children
    }));
};
var ContentListNews = function(_param) {
    var children = _param.children, singleRow = _param.singleRow, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "singleRow"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("ml-0 grid grid-cols-1 grid-rows-2 gap-5 [grid-auto-columns:1fr] tablet:ml-auto tablet:grid-cols-2 desktop:grid-cols-3 [&_a]:mx-0 [&_a]:my-5 [&_a]:no-underline ", singleRow != undefined && variants.ContentListNews.singleRow[singleRow.toString()])
    }, rest), {
        children: children
    }));
};
var BillboardContainer = function(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: "m-0 hidden tablet:mx-[-8.335%] tablet:my-0 tablet:flex"
    }, rest), {
        children: children
    }));
};


/***/ }),

/***/ 4775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _hooks_useOutsideClickRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6425);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6008);




function Modal(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, children = param.children, iconOutsideBox = param.iconOutsideBox, noPadding = param.noPadding, limitHeight = param.limitHeight;
    var variants = {
        ModalContainer: {
            isOpen: {
                true: "opacity-100 z-[9999]",
                false: "opacity-0 z-[-1]"
            }
        },
        ModalBox: {
            iconOutsideBox: {
                true: "p-0 w-[initial]",
                false: ""
            },
            noPadding: {
                true: "p-0",
                false: ""
            },
            limitHeight: {
                true: "tablet:h-[initial] tablet:overflow-y-[initial] h-full overflow-y-auto",
                false: ""
            }
        },
        ModalCloseIcon: {
            iconOutsideBox: {
                true: "-top-12 right-0 text-mglGray50",
                false: ""
            }
        }
    };
    var modalRef = (0,_hooks_useOutsideClickRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        setIsOpen: setIsOpen
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("fixed left-0 top-0 flex h-full w-full items-center justify-center overflow-auto bg-black/90 transition-all duration-300 ease-ease [&>svg]:cursor-pointer [&>svg]:text-2xl", variants.ModalContainer.isOpen[isOpen.toString()]),
        role: "dialog",
        "aria-modal": isOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative h-full max-h-full min-h-[336px] w-full max-w-[760px] overflow-y-auto rounded-none bg-mglGray50 pb-8 pr-0 pt-16 tablet:max-h-[90%] tablet:rounded", iconOutsideBox != undefined && variants.ModalBox.iconOutsideBox[iconOutsideBox.toString()], noPadding != undefined && variants.ModalBox.noPadding[noPadding.toString()], limitHeight != undefined && variants.ModalBox.limitHeight[limitHeight.toString()]),
            ref: modalRef,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("absolute right-4 top-4 cursor-pointer text-lg text-black/40", iconOutsideBox != undefined && variants.ModalCloseIcon.iconOutsideBox[iconOutsideBox.toString()]),
                    onClick: function() {
                        return setIsOpen(false);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        icon: "mdi:close"
                    })
                }),
                children
            ]
        })
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 8662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ axiosRetry; }
/* harmony export */ });
/* unused harmony exports namespace, isNetworkError, isRetryableError, isSafeRequestError, isIdempotentRequestError, isNetworkOrIdempotentRequestError, exponentialDelay */
/* harmony import */ var is_retry_allowed__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9367);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var namespace = 'axios-retry';
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isNetworkError(error) {
  return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
  error.code !== 'ECONNABORTED' && // Prevents retrying timed out requests
  is_retry_allowed__WEBPACK_IMPORTED_MODULE_0__(error); // Prevents retrying unsafe errors
}
var SAFE_HTTP_METHODS = ['get', 'head', 'options'];
var IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat(['put', 'delete']);
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isRetryableError(error) {
  return error.code !== 'ECONNABORTED' && (!error.response || error.response.status >= 500 && error.response.status <= 599);
}
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isSafeRequestError(error) {
  if (!error.config) {
    // Cannot determine if the request can be retried
    return false;
  }

  return isRetryableError(error) && SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isIdempotentRequestError(error) {
  if (!error.config) {
    // Cannot determine if the request can be retried
    return false;
  }

  return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isNetworkOrIdempotentRequestError(error) {
  return isNetworkError(error) || isIdempotentRequestError(error);
}
/**
 * @return {number} - delay in milliseconds, always 0
 */

function noDelay() {
  return 0;
}
/**
 * Set delayFactor 1000 for an exponential delay to occur on the order
 * of seconds
 * @param  {number} [retryNumber=0]
 * @param  {Error}  error - unused; for existing API of retryDelay callback
 * @param  {number} [delayFactor=100] milliseconds
 * @return {number} - delay in milliseconds
 */


function exponentialDelay() {
  var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var error = arguments.length > 1 ? arguments[1] : undefined;
  var delayFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  var delay = Math.pow(2, retryNumber) * delayFactor;
  var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay

  return delay + randomSum;
}
/**
 * Initializes and returns the retry state for the given request/config
 * @param  {AxiosRequestConfig} config
 * @return {Object}
 */

function getCurrentState(config) {
  var currentState = config[namespace] || {};
  currentState.retryCount = currentState.retryCount || 0;
  config[namespace] = currentState;
  return currentState;
}
/**
 * Returns the axios-retry options for the current request
 * @param  {AxiosRequestConfig} config
 * @param  {AxiosRetryConfig} defaultOptions
 * @return {AxiosRetryConfig}
 */


function getRequestOptions(config, defaultOptions) {
  return _objectSpread(_objectSpread({}, defaultOptions), config[namespace]);
}
/**
 * @param  {Axios} axios
 * @param  {AxiosRequestConfig} config
 */


function fixConfig(axios, config) {
  if (axios.defaults.agent === config.agent) {
    delete config.agent;
  }

  if (axios.defaults.httpAgent === config.httpAgent) {
    delete config.httpAgent;
  }

  if (axios.defaults.httpsAgent === config.httpsAgent) {
    delete config.httpsAgent;
  }
}
/**
 * Checks retryCondition if request can be retried. Handles it's retruning value or Promise.
 * @param  {number} retries
 * @param  {Function} retryCondition
 * @param  {Object} currentState
 * @param  {Error} error
 * @return {boolean}
 */


function shouldRetry(_x, _x2, _x3, _x4) {
  return _shouldRetry.apply(this, arguments);
}
/**
 * Adds response interceptors to an axios instance to retry requests failed due to network issues
 *
 * @example
 *
 * import axios from 'axios';
 *
 * axiosRetry(axios, { retries: 3 });
 *
 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Exponential back-off retry delay between requests
 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
 *
 * // Custom retry delay
 * axiosRetry(axios, { retryDelay : (retryCount) => {
 *   return retryCount * 1000;
 * }});
 *
 * // Also works with custom axios instances
 * const client = axios.create({ baseURL: 'http://example.com' });
 * axiosRetry(client, { retries: 3 });
 *
 * client.get('/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Allows request-specific configuration
 * client
 *   .get('/test', {
 *     'axios-retry': {
 *       retries: 0
 *     }
 *   })
 *   .catch(error => { // The first request fails
 *     error !== undefined
 *   });
 *
 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
 * @param {Object} [defaultOptions]
 * @param {number} [defaultOptions.retries=3] Number of retries
 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
 *        Defines if the timeout should be reset between retries
 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
 *        A function to determine if the error can be retried
 * @param {Function} [defaultOptions.retryDelay=noDelay]
 *        A function to determine the delay between retry requests
 * @param {Function} [defaultOptions.onRetry=()=>{}]
 *        A function to get notified when a retry occurs
 */


function _shouldRetry() {
  _shouldRetry = _asyncToGenerator(function* (retries, retryCondition, currentState, error) {
    var shouldRetryOrPromise = currentState.retryCount < retries && retryCondition(error); // This could be a promise

    if (typeof shouldRetryOrPromise === 'object') {
      try {
        var shouldRetryPromiseResult = yield shouldRetryOrPromise; // keep return true unless shouldRetryPromiseResult return false for compatibility

        return shouldRetryPromiseResult !== false;
      } catch (_err) {
        return false;
      }
    }

    return shouldRetryOrPromise;
  });
  return _shouldRetry.apply(this, arguments);
}

function axiosRetry(axios, defaultOptions) {
  axios.interceptors.request.use(config => {
    var currentState = getCurrentState(config);
    currentState.lastRequestTime = Date.now();
    return config;
  });
  axios.interceptors.response.use(null, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (error) {
      var {
        config
      } = error; // If we have no information to retry the request

      if (!config) {
        return Promise.reject(error);
      }

      var {
        retries = 3,
        retryCondition = isNetworkOrIdempotentRequestError,
        retryDelay = noDelay,
        shouldResetTimeout = false,
        onRetry = () => {}
      } = getRequestOptions(config, defaultOptions);
      var currentState = getCurrentState(config);

      if (yield shouldRetry(retries, retryCondition, currentState, error)) {
        currentState.retryCount += 1;
        var delay = retryDelay(currentState.retryCount, error); // Axios fails merging this configuration to the default configuration because it has an issue
        // with circular structures: https://github.com/mzabriskie/axios/issues/370

        fixConfig(axios, config);

        if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
          var lastRequestDuration = Date.now() - currentState.lastRequestTime;
          var timeout = config.timeout - lastRequestDuration - delay;

          if (timeout <= 0) {
            return Promise.reject(error);
          }

          config.timeout = timeout;
        }

        config.transformRequest = [data => data];
        onRetry(currentState.retryCount, error, config);
        return new Promise(resolve => setTimeout(() => resolve(axios(config)), delay));
      }

      return Promise.reject(error);
    });

    return function (_x5) {
      return _ref.apply(this, arguments);
    };
  }());
} // Compatibility with CommonJS

axiosRetry.isNetworkError = isNetworkError;
axiosRetry.isSafeRequestError = isSafeRequestError;
axiosRetry.isIdempotentRequestError = isIdempotentRequestError;
axiosRetry.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
axiosRetry.exponentialDelay = exponentialDelay;
axiosRetry.isRetryableError = isRetryableError;
//# sourceMappingURL=index.js.map

/***/ })

}]);